import { css } from '@emotion/react';

export const root = ([size, fontSize]: string[]) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${size};
  height: ${size};
  border-radius: 50%;
  background: #285e61;
  font-size: ${fontSize};
  color: var(--color-white);
`;
